import { Loader } from '@nosinovacao/fe-icons';
import { Button, Checkbox, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type CompleteProps } from '../-model/props';

const KEY_PREFIX = 'Security.AuthenticatorAppCard.Setup.Complete';

export function CompleteLight({
  codes,
  confirmed,
  download,
  finish,
  loading,
  setConfirmed,
}: Readonly<CompleteProps>) {
  const { t } = useI18n();
  return (
    <>
      <div className="grid flex-1 auto-rows-max content-start gap-6 overflow-y-auto">
        <ul className="grid grid-cols-2 gap-x-2 gap-y-3 rounded-lg bg-nos-neutral-75 px-4 py-6 text-center text-nos-neutral-800 font-text-p2">
          {codes.map((code) => (
            <li key={code}>{code}</li>
          ))}
        </ul>
        <Button
          skin="light"
          variant="tertiary"
          type="button"
          onClick={download}
          data-tid="download-codes-button"
          className="justify-self-center"
        >
          {t(`${KEY_PREFIX}.Download`)}
        </Button>
      </div>
      <Checkbox
        id="recovery-codes-saved"
        data-tid="recovery-codes-saved-checkbox"
        skin="light"
        checked={confirmed}
        onChange={() => setConfirmed(!confirmed)}
        label={t(`${KEY_PREFIX}.Confirm`).toString()}
      />
      <footer className="grid pt-2">
        <Button
          skin="light"
          type="button"
          onClick={finish}
          disabled={!confirmed || loading}
          data-tid="finish-button"
          className="w-full px-4 tablet:w-fit tablet:justify-self-start"
        >
          {loading ? <Loader height={24} width={24} /> : t(`${KEY_PREFIX}.Button`)}
        </Button>
      </footer>
    </>
  );
}
